// Configuración centralizada de imágenes para el componente Transformacion
export const transformacionImages = [
  {
    number: '01',
    backgroundImage: '/transformaciones/primera.webp',
    isContentCard: false
  },
  {
    number: '02',
    backgroundImage: '/transformaciones/segunda.png',
    isContentCard: false
  },
  {
    number: '03',
    backgroundImage: '/transformaciones/tercera.png',
    isContentCard: false
  },
  {
    number: '04',
    backgroundImage: '/transformaciones/cuarta.png',
    isContentCard: false
  },
  {
    number: '05',
    isContentCard: true,
    title: 'La transformación empieza adentro.',
    titleBold: 'Vos también podés.',
    button1: 'Sumate al team Maquifit',
    button1Url: '#',
    button2: 'Ver más',
    button2Url: 'https://www.instagram.com/stories/highlights/18145249066388436/'
  },
  {
    number: '06',
    backgroundImage: '/transformaciones/ultima.png',
    isContentCard: false
  }
];

// URLs de imágenes para precarga
export const imageUrls = [
  '/transformaciones/primera.png',
  '/transformaciones/segunda.png',
  '/transformaciones/tercera.png',
  '/transformaciones/cuarta.png',
  '/transformaciones/ultima.png'
];

